import { render, staticRenderFns } from "./9Notices.vue?vue&type=template&id=5ffd5a0b&scoped=true"
import script from "./9Notices.vue?vue&type=script&lang=js"
export * from "./9Notices.vue?vue&type=script&lang=js"
import style0 from "./9Notices.vue?vue&type=style&index=0&id=5ffd5a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd5a0b",
  null
  
)

export default component.exports